module.exports = __webpack_public_path__ + "static/media/xiaoguo.2aedc125.webp";